export const A2UI_GALLERY_CARD_HOVER_EVENT = 'a2ui-gallery:hovered-example';
export const A2UI_GALLERY_SIDEBAR_FOCUS_EVENT = 'a2ui-gallery:sidebar-focus';
